export default __webpack_public_path__ + "static/media/phone-alt-solid.e4208225.svg";